export const IsCareProviderResponse = ({ props }) => ([
  { text: 'Stellungnahme', value: '::false' },
  { text: 'Mitteilung', value: '::true' },
])
